import { FC, useContext, useEffect, useRef, useState } from 'react';

import { BottomIcon, Button, TopIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { ESyncScope } from 'types';

import s from './AddButton.module.scss';
import { AddButtonProps } from './interfaces';

export const AddButton: FC<AddButtonProps> = ({
  onAdd,
  disabled,
  setNewGroupName,
  loading,
}) => {
  const { t } = useContext(LocalizationContext);
  const dropdownDeleteRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        isOpen &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={wrapperRef} className={s.button_block}>
      <Button
        variant="secondary"
        onClick={() => setIsOpen(!isOpen)}
        fullWidth
        disabled={disabled}
        className={cn(s.button, isOpen && s.active)}
        isLoading={loading}
      >
        {t('group.modal.button.add')}
        <div className={s.arrow} onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <TopIcon size="l" color={disabled ? 'disable' : 'link-info'} />
          ) : (
            <BottomIcon size="l" color={disabled ? 'disable' : 'link-info'} />
          )}
        </div>
      </Button>

      {isOpen && (
        <div ref={dropdownDeleteRef} className={s.dropdown}>
          <div
            className={s.drop_item}
            onClick={() => {
              onAdd(ESyncScope.LOCAL);
              setIsOpen(false);
              setNewGroupName('');
            }}
          >
            {t('application.manager.button_3')}
          </div>
          <div
            className={s.drop_item}
            onClick={() => {
              onAdd(ESyncScope.NETWORK);
              setIsOpen(false);
              setNewGroupName('');
            }}
          >
            {t('application.manager.button_4')}
          </div>
        </div>
      )}
    </div>
  );
};
